import Box from '@mui/material/Box';

import { styled } from 'helpers';

const Container = styled(Box)`
  display: inline-flex;
  & .MuiAutocomplete-root {
    & .MuiAutocomplete-inputRoot {
      padding: 0px;
      & .MuiAutocomplete-input {
        padding: 8px 16px;
        line-height: 1.5;
        height: unset;
        min-width: 72px;

        &::placeholder {
          color: ${({ theme }) => theme.palette.blueGrey['A300']};
          opacity: 1;
        }
      }
    }
  }

  .MuiAutocomplete-listbox {
    max-height: 250px;
  }
  .MuiSelect-icon {
    display: none;
  }

  & .MuiMenu-paper {
    max-height: 264px;
  }

  & .MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding-right: 14px;
  }

  /* input styles -- disabled */
  & .MuiInputBase-input.Mui-disabled {
    background-color: ${({ theme }) => theme.palette.secondary.main};
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
    -webkit-text-fill-color: unset; // needed to remove an MUI style that messes with font color
  }
  & .MuiOutlinedInput-root.Mui-disabled {
    /* used to keep the background-color from overflowing outside the border radius */
    overflow: hidden;
  }
`;

export { Container };
